<template>
  <!--BU管理-->
  <div id="contentList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal;">
          <p>
            <input @keyup.enter="getList(1)" class="allInput" placeholder="BU" v-model="postData.buName">
          </p>
          <button class="redButton" @click="selectCont">
            搜索
          </button>
        </div>
        <div style="width: auto;">
          <button class="redButtonTwo " @click="editToUrl">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
            <tr>
              <th>BU</th>
              <th>Brand CN</th>
              <th>Brand EN</th>

              <th>更新时间</th>
              <th>创建人</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(item, index) in myList">
              <td>{{item.buName}}</td>
              <td>{{item.brandCN}}</td>
              <td>{{item.brandEN}}</td>

              <td style="width: 200px;">{{item.lastUpdateTime}}</td>
              <td style="width: 120px;">{{item.creator}}</td>
              <td class="colorBlue">
                <div class="icon more iconfont icongengduo moreOperations">
                  <ul>
                    <li @click="editContentType(item)">编辑</li>
                    <li @click="deleteType(item)">删除</li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage"
        :page="page" :explain="0"></page>
    </div>
    <model v-if="newModel" :buttonType="0" :title="'新建BU'" :minWidth="'500px'" v-on:on-cancel="newModel = false"
      v-on:on-confirm="confirModel()">
      <div style="height: 300px">
        <ul class="allUL">

          <li><span style="text-align: right;"><span style="color: red;">*</span> BU</span> <abbr>
              <input style="width: 290px" class="allInput" v-model="cateModel.BUName" type="text" maxlength="8">
            </abbr></li>

          <li><span style="text-align: right;"><span style="color: red;">*</span> 品牌</span> <abbr>
              <allSelect :width="300" style="display: inline-block" :chooseData="allProduct" :needReturn="'brandCode'"
                :placeholder="'请选择'" :matchValue="'brandCN'" :showValue="'{{brandCN}}'" v-model="cateModel.BrandCode">
              </allSelect>
            </abbr></li>


        </ul>
      </div>
    </model>

    <model v-if="newModel2" :buttonType="0" :title="'编辑BU'" :minWidth="'500px'" v-on:on-cancel="newModel2 = false"
      v-on:on-confirm="confirModel2()">
      <div style="height: 300px">
        <ul class="allUL">

          <li><span style="text-align: right;"><span style="color: red;">*</span> BU</span> <abbr>
              <input style="width: 290px" class="allInput" :disabled="true" v-model="editModel.BUName" type="text">
            </abbr></li>

          <li><span style="text-align: right;"><span style="color: red;">*</span> 品牌</span> <abbr>
              <allSelect :width="300" style="display: inline-block" :chooseData="allProduct" :needReturn="'brandCode'"
                :placeholder="'请选择'" :matchValue="'brandCN'" :showValue="'{{brandCN}}'" v-model="editModel.BrandCode">
              </allSelect>
            </abbr></li>


        </ul>
      </div>
    </model>
  </div>
</template>

<script>
  export default {
    name: 'contentList',
    data() {
      return {
        newModel: false,
        newModel2:false,
        showModel: false,

        totalPage: 1,
        totalCount: 0,
        page: 1,
        cateModel: {
          BUName: '',
          BrandCode: ''
        },
        editModel:{
          BrandCode:'',
          BUName: '',
          BrandId: ''
        },
        allProduct: [],
        postData: {
          buName: '',
          pageIndex: 1,
          pageSize: this.$commonJs.commonPageSize
        },
        myList: [],
      }
    },
    created() {
      this.getList(1)
      this.getAllProDuct()
    },
    methods: {
      deleteType(item) {
        this.$commonJs.doubleComfirm({
          content: '确定删除此BU？',
          successFun: msg => {
            this.$axiox.get('/api/BUController/DelteBU?BU_BrandId=' + item.bU_BrandId).then(msg => {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '删除成功',
                stayTime: 5
              })
              this.getList(1)
            })
          },
          errorFun: msg => {}
        })
      },
      getAllProDuct() {
        this.$axiox.get('/api/Dict/Get/brands').then(p => {
          this.allProduct = p
        })
      },
      // 新建
      editToUrl() {
        this.newModel = true
        this.cateModel = {
          BUName: '',
          BrandCode: ''
        }
      },
      getList(pageIndex) {
        this.postData.pageIndex = pageIndex
        this.$axiox.post('/api/BUController/page/List', this.postData).then(msg => {
          this.myList = msg.data
          this.totalCount = msg.total
          if(!this.pageSize)this.pageSize=10
          this.totalPage = Math.ceil(msg.total / this.pageSize)
        })
      },
      selectCont() {
        this.getList(1)
      },
      confirModel() {
        if (!this.cateModel.BUName) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请输入分类名称',
            stayTime: 5
          })
          return
        }
        if (!this.cateModel.BrandCode) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请选择产品',
            stayTime: 5
          })
          return
        }

          this.$axiox.get('/api/BUController/AddBU?BUName='+this.cateModel.BUName + '&BrandCode='+this.cateModel.BrandCode).then(p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '新建成功',
              stayTime: 5
            })
            this.getList(1)
            this.newModel = false
          })

      },
      editContentType(item) {
        this.editModel = {
          BrandCode:item.brandCode,
          BUName: item.buName,
          BrandId:item.bU_BrandId,
        }
        this.newModel2 = true
      },
      confirModel2() {
        if (!this.editModel.BrandId) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请选择产品',
            stayTime: 5
          })
          return
        }

          this.$axiox.get('/api/BUController/UpdateBU?BU_BrandId='+this.editModel.BrandId + '&BrandCode='+this.editModel.BrandCode).then(p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '编辑成功',
              stayTime: 5
            })
            this.getList(1)
            this.newModel2 = false
          })

      },
      selectEmpty() {
        this.postData.buName = ''
      }
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/buBrandList.vue